export const enUS_publicTips = {
  'gloabal.tips.notfound': 'Sorry, the page you visited does not exist.',
  'gloabal.tips.unauthorized': 'Sorry, you are not authorized to access this page.',
  'gloabal.tips.loginResult': 'When you see this page, it means you are logged in.',
  'gloabal.tips.goToLogin': 'Go To Login',
  'gloabal.tips.username': 'Username',
  'gloabal.tips.password': 'Password',
  'gloabal.tips.login': 'Login',
  'gloabal.tips.backHome': 'Back Home',
  'gloabal.tips.operation': 'Operation',
  'gloabal.tips.authorize': 'Authorize',
  'gloabal.tips.delete': 'Delete',
  'gloabal.tips.create': 'Create',
  'gloabal.tips.modify': 'Modify',
  'gloabal.tips.search': 'Search',
  'gloabal.tips.reset': 'Reset',
  'gloabal.tips.deleteConfirm': 'Do you Want to delete these items?',
  'gloabal.tips.loading': 'Loading...',
  'gloabal.tips.theme.darkTooltip': 'Switch to dark theme',
  'gloabal.tips.theme.lightTooltip': 'Switch to light theme',
};
